import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { faMagnifyingGlass, faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {ContentService} from "../../../data-access/content.service";
import * as _ from "lodash"
import {APIResponse} from "../../../../shared/data-access/api-response.model";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
export interface LearningObjective {
  name: string,
  learningobjective_id: number,
  problemtemplate_count: number,
  createdate: Date,
  last_updated: Date,
  subject_id: number,
  ccl_id?: number
}
interface OnInit {
  ngOnInit(): void
}

@Component({
    selector: 'learningObjectiveList',
    templateUrl: './learningObjective.html',
    styleUrls: ['../../userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    standalone: false
})
export class LearningObjectiveList implements OnInit {
  constructor(private router: Router, private route: ActivatedRoute, private contentService: ContentService) {
  }
  errorDialog = false
  errorText  = ""
  isOpened = true
  faMagnifyingGlass = faMagnifyingGlass
  faChevronRight = faChevronRight
  faChevronLeft = faChevronLeft
  searchText = ""
  learningObjectives: LearningObjective[] = []
  isLoading = false
  pageNumber: number = 0
  maxPage: number = 0
  subject_id: string = ""
  ccl_id: string = ""
  isDescending: boolean = true
  primaryColor = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; flex-shrink: 1;`
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'Subject List',
    route: 'dashboard/ContentViewer/SubjectList'
  }, {
    text: 'CCL Tree',
    route: 'dashboard/ContentViewer/SubjectList/CCLTree'
  }]
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if(params['subject_id'] != null)
        this.subject_id = params['subject_id']
      if(params['ccl_id'] != null)
        this.ccl_id = params['ccl_id']

      if(this.ccl_id != "") {
        this.isLoading = true
        this.contentService.getLearningObjList("", this.ccl_id, 0).subscribe((response) => {
          this.handleLearningObjectiveResponse(response)
        })
      } else {
        this.isLoading = true
        this.contentService.getLearningObjList(this.subject_id, "", 0).subscribe((response) => {
          this.handleLearningObjectiveResponse(response)
        })
      }

      if(this.subject_id !== "")
        this.breadcrumbNavs[0].queryParams = {queryParams: {subject_id: this.subject_id}}
      else
        this.breadcrumbNavs[0].queryParams = {queryParams: {ccl_id: this.ccl_id}}
    })
  }

  SubjectList() {
    this.router.navigate(['dashboard/ContentViewer/SubjectList'])
  }

  CCLTree() {
    if(this.subject_id !== "")
      this.router.navigate(['dashboard/ContentViewer/SubjectList/CCLTree'], {queryParams: {subject_id: this.subject_id}})
    else
      this.router.navigate(['dashboard/ContentViewer/SubjectList/CCLTree'], {queryParams: {ccl_id: this.ccl_id}})
  }

  decrementPage() {
    if(this.pageNumber !== 0)
      this.pageNumber -= 1
    this.getPage()
  }

  incrementPage() {
    if(this.pageNumber + 1 !== this.maxPage + 1)
      this.pageNumber += 1;
    this.getPage()
  }

  getPage() {
    this.isLoading = true
    if(this.ccl_id != "") {
      this.contentService.getLearningObjList("", this.ccl_id, this.pageNumber, 25, this.searchText).subscribe((response) => {
        this.handleLearningObjectiveResponse(response)
      })
    } else {
      this.contentService.getLearningObjList(this.subject_id, "", 0, 25, this.searchText).subscribe((response) => {
        this.handleLearningObjectiveResponse(response)
      })
    }
  }

  debounceSearch = _.debounce(() => {
    this.isLoading = true
    if(this.ccl_id != "") {
      this.contentService.getLearningObjList("", this.ccl_id, 0, 25, this.searchText).subscribe((response) => {
        this.handleLearningObjectiveResponse(response)
      })
    } else {
      this.contentService.getLearningObjList(this.subject_id, "", 0, 25, this.searchText).subscribe((response) => {
        this.handleLearningObjectiveResponse(response)
      })
    }
  }, 750)

  descending(ascend: boolean) {
    this.isLoading = true
    this.isDescending = !ascend
    if(this.ccl_id != "") {
      this.isLoading = true
      this.contentService.getLearningObjList("", this.ccl_id, 0, 25, this.searchText, "", ascend).subscribe((response) => {
        this.handleLearningObjectiveResponse(response)
      })
    } else {
      this.isLoading = true
      this.contentService.getLearningObjList(this.subject_id, "", 0, 25, this.searchText, "", ascend).subscribe((response) => {
        this.handleLearningObjectiveResponse(response)
      })
    }
  }

  problemTemplate(learningobjective_id: number) {
    this.router.navigate(['dashboard/ContentViewer/SubjectList/CCLTree/LearningObjectives/ProblemTemplates'], {queryParams: {learningobjective_id: learningobjective_id, ccl_id: this.ccl_id, subject_id: this.subject_id}});
  }

  handleLearningObjectiveResponse(response: APIResponse) {
    if(response.success) {
      this.learningObjectives = response.result.items
      this.maxPage = Math.floor(response.result.totalcount / 25)
    } else {
      this.errorDialog = true
      this.errorText = response.msg
    }
    this.isLoading = false
  }
}
